import { BaseRouteService } from 'core/services';

class LocalDoctorRouteService extends BaseRouteService {
    constructor() {
        super('local-doctors');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,isNiko}', filter);
    }

    get(id) {
        return super.get(this.base + '/{id}', id);
    }

    sync(){
        return super.update(this.base + '/sync');
    }

    nikoSync(){
        return super.update(this.base + '/sync/niko');
    }
}

export default LocalDoctorRouteService;
